import { SaleLotCategory } from "./LotCategoryData";
import { AgTechIndex, Index } from "@agtech/core/utilities/AgTechUtilities";
import { AgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";

export const LotDataGetLotCategoriesQuery: AgTechQuery<any, AgTechIndex<SaleLotCategory>> = {
    queryKey: () => ['LotCategories'],
    query: (props) => {
        return props.http.getEntity<SaleLotCategory[], AgTechIndex<SaleLotCategory>>({
            request: 'LotCategory',
            convert: categories => Index(categories, category => category.id)
        });
    },
    content: {
        loadingText: 'Loading lot categories...',
        failureText: 'Failed to load lot categories.'
    }
}